const dictionnaire = {

  /**
   * Sidebar
   */
  sidebar: {
    logout: { button: "Logout" },
    account: { button: "My account" },
    connectedAs: { label: "Connected as" },
    backTo: { button: "Back to" },
  },

  /**
   * Global
   */
  global: {
    // Liste des pages
    universe: { title: "Universe" },
    start: { title: "Parcours Marketing" },
    linelists: { title: "Linelists" },
    orderList: { title: "Orders" },
    orderHistory: { title: "Orders History" },
    brandnameList: { title: "Brand Name" },
    marketSetup: { title: "Market Setup" },
    edi: { title: "EDI" },
    importstock: { title: "Stocks" },
    importproduct: { title: "Products" },
    codification: { title: "Sort Parameters" },
    users: { title: "Users" },
    groups: { title: "Groups" },
    savethe: { title: "Save The" },
    archives: { title: "Archives" },
    admin: { title: "Admin Panel" },
    tasks: { title: "My Tasks" },
    stock: { title: "Stock" },
  },

  /**
   * Compte et session
   */
  account: {
    login: {
      button: "Login",
      error: "Login failed"
    },
    back: { button: "Back" },
    mail: {
      label: "Email address",
      error: "Email required",
      placeholder: "name@address.com",
      p1: "The email has been sent",
      p2: "Please check your inbox",
      span: "Unable to find your account"
    },
    password: {
      label: "Password",
      error: "Password required",
      placeholder: "Your password"
    },
    passwordForgot: { button: "Forgot password?" },
    passwordReset: {
      button: "Reset your password",
      label: "Remember your password?"
    },
    choose: {
      title: "Choose a new password for",
      label1: "New password",
      label2: "Confirm new password",
      errorPassword: "Required field",
      errorMatch: "Password doesn't match",
      button: "Set password",
      p: "Password has been changed",
      rules: "Password must meet complexity requirements",
      expired: "Activation link has expired"
    },
    continue: { button: "Continue" }
  },
  session: {
    heading: {
      expired: "Session expired",
      reset: "Password reset"
    },
    subheading: {
      expired: "Your session has expired, please login again",
      reset: "Enter your email address to get a reset link"
    },
    alert: {
      p1: "Email has been sent",
      p2: "Please check your inbox",
      error: "Login failed",
      success: "Login successful"
    },
    password: {
      label: "Password for",
      button: "I'm not"
    }
  }

}
export { dictionnaire };